var classes = {"container":"index-module_container__JaNg0"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
